export default "__VITE_ASSET__ec2223a0__"